module.exports = __webpack_public_path__ + "img/welcome-to-real.dd0931b6.svg";